import React, { useState, ChangeEvent, KeyboardEvent, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

// import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";

import "./login.css";
// import "./login.css";
// import { C } from "react-router/dist/development/index-react-server-client-BKpa2trA";

const Login = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState<string>("");
  const [resOtp, setResOtp] = useState<string>(""); // For testing OTP display
  const [otpSent, setOtpSent] = useState<boolean>(false);
  const [otpDigits, setOtpDigits] = useState<string[]>(["", "", "", ""]);
  const [errors, setErrors] = useState<{ mobile?: string; otp?: string }>({});
  const [loading, setLoading] = useState<boolean>(false);

  const otpRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
  ];

  //  Mobile Input Change Handler
  const handleMobileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setMobile(value);
      setErrors((prev) => ({ ...prev, mobile: undefined }));
    }
  };

  //  OTP Input Change Handler
  const handleOtpChange = (index: number, value: string) => {
    if (!/^\d?$/.test(value)) return;
    const updatedOtp = [...otpDigits];
    updatedOtp[index] = value;
    setOtpDigits(updatedOtp);

    if (value && index < 3) {
      otpRefs[index + 1]?.current?.focus();
    }

    setErrors((prev) => ({ ...prev, otp: undefined }));
  };

  //  Handle Backspace in OTP Fields
  const handleOtpKeyDown = (
    index: number,
    e: KeyboardEvent<HTMLInputElement>,
  ) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      otpRefs[index - 1]?.current?.focus();
    }
  };

  // Send OTP
  const handleSendOTP = async () => {
    if (!/^\d{10}$/.test(mobile)) {
      const errorMsg = "Please enter a valid 10-digit mobile number";
      setErrors({ mobile: errorMsg });
      toast.error(errorMsg);
      return;
    }
    setLoading(true);
    setErrors({});
    try {
      const payload = {
        phoneNumber: mobile,
        type: "ORG_WEB",
      };
      const response = await axios.post(webServiceUrl.SEND_OTP, payload);
      // console.log(response?.data?.success, "data hai response fffffffffffffffff")
      if (response?.data?.success) {
        toast.success(response?.data?.message || "OTP sent successfully");
        setOtpSent(true);
        setOtpDigits(["", "", "", ""]);
        setResOtp(response?.data?.otp);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      // toast.error(error?.message)
      console.log(error, "error catch block ka hai");
    } finally {
      setLoading(false);
    }
  };

  //  Verify OTP
  const handleVerifyOTP = async () => {
    const otp = otpDigits.join("");
    if (otp.length !== 4) {
      setErrors({ otp: "Please enter a valid 4-digit OTP" });
      toast.error("Invalid OTP");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(webServiceUrl.VERIFY_OTP, {
        phoneNumber: mobile,
        otp,
        user_type: "ORG_WEB",
        user: "ORG",
      });

      if (response?.data?.success) {
        const { accessToken, data } = response.data;
        const { organization_id, organization_name } = data;

        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("organization_id", organization_id);
        localStorage.setItem("organization_name", organization_name);
        localStorage.setItem("org-id", organization_id);

        toast.success("Login successful");
        window.location.href = "/lead-dashboard";
        // navigate('/lead-dashboard');
      } else {
        toast.error("Incorrect OTP");
        setErrors({ otp: "Incorrect OTP" });
      }
    } catch (error) {
      console.error("OTP Verification Error:", error);
      toast.error("Something went wrong during OTP verification");
    } finally {
      setLoading(false);
    }
  };

  // Unified Button Handler
  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault(); // 💯 Prevent page reload
    if (otpSent) {
      handleVerifyOTP();
    } else {
      handleSendOTP();
    }
  };

  return (
    <div className="login-page">
      <div className="login-wrapper">
        <div className="left-panel">
          <div className="left-content">
            <h1 className="text-light">
              Nestfin: Uniting Teams,
              <br /> Streamlining Sales
            </h1>
            <p>
              Efficiently manage your workforce,
              <br /> streamline operations effortlessly.
            </p>
          </div>
        </div>

        <div className="right-panel">
          <form className="login-card" onSubmit={(e) => e.preventDefault()}>
            <img
              src="assets/img/logo.png"
              alt="Nestfin Logo"
              className="login-logo"
            />

            <h2 className="login-title">Welcome Back</h2>
            <p className="login-subtext">
              Enter your mobile number to get started
              {/*   <span style={{ fontWeight: "bold", color: "#1e90ff" }}>
                {resOtp && ` (OTP: ${resOtp})`}
              </span> */}
            </p>

            {/* Mobile Input */}
            <label htmlFor="mobile">Mobile Number</label>
            <div className="input-group">
              <span className="input-group-text">+91</span>
              <input
                type="text"
                id="mobile"
                value={mobile}
                onChange={handleMobileChange}
                className="form-control"
                placeholder="Enter 10-digit number"
                maxLength={10}
                inputMode="numeric"
              />
            </div>
            {errors.mobile && <p className="text-danger">{errors.mobile}</p>}

            {/* OTP Input */}
            {otpSent && (
              <>
                <label>Enter OTP</label>
                <div className="otp-box">
                  {otpDigits.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength={1}
                      ref={otpRefs[index]}
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    />
                  ))}
                </div>
                {errors.otp && <p className="text-danger">{errors.otp}</p>}
              </>
            )}

            {/* Button */}
            <button
              type="button"
              className={`btn-login ${otpSent ? "btn-verify" : "btn-send"}`}
              onClick={handleButtonClick}
              disabled={loading}
              style={{ marginTop: "40px" }}
            >
              {loading ? (
                <>
                  <span className="spinner1" />
                  {otpSent ? "Verifying..." : "Sending..."}
                </>
              ) : otpSent ? (
                "Verify OTP"
              ) : (
                "Send OTP"
              )}
            </button>

            <div className="footer-text mt-5">
              © {new Date().getFullYear()} Nestfin Technology. All rights
              reserved.
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;

// ---old code ------------

// import React, { useState, ChangeEvent, KeyboardEvent, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
// import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
// // import Loader from "../../../Loader";
// // import '../../../core/common/loader/index'

// import './login.css';
// import axios from "axios";

// const Login = () => {
//   const navigation = useNavigate();
//   const [mobile, setMobile] = useState<string>("");
//   const [resOtp, setResOtp] = useState<string>("");
//   const [otpSent, setOtpSent] = useState<boolean>(false);
//   const [otpDigits, setOtpDigits] = useState<string[]>(["", "", "", ""]);
//   const [errors, setErrors] = useState<{ mobile?: string; otp?: string }>({});
//   const [loading, setLoading] = useState<boolean>(false);

//   const otpRefs = [
//     useRef<HTMLInputElement>(null),
//     useRef<HTMLInputElement>(null),
//     useRef<HTMLInputElement>(null),
//     useRef<HTMLInputElement>(null),
//   ];

//   const handleMobileChange = (e: ChangeEvent<HTMLInputElement>) => {
//     setMobile(e.target.value);
//     setErrors((prev) => ({ ...prev, mobile: undefined }));
//   };

//   const handleOtpChange = (index: number, value: string) => {
//     if (!/^\d?$/.test(value)) return;
//     const updatedOtp = [...otpDigits];
//     updatedOtp[index] = value;
//     setOtpDigits(updatedOtp);

//     if (value && index < 3) {
//       otpRefs[index + 1]?.current?.focus();
//     }

//     setErrors((prev) => ({ ...prev, otp: undefined }));
//   };

//   const handleOtpKeyDown = (index: number, e: KeyboardEvent<HTMLInputElement>) => {
//     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
//       otpRefs[index - 1]?.current?.focus();
//     }
//   };

//   const handleSendOTP = async (e: any) => {
//        e.preventDefault();
//     // if (!/^\d{handleSendOTP10}$/.test(mobile)) {
//     //   setErrors({ mobile: "Please enter a valid 10-digit mobile number" });
//     //   return;
//     // }
//     // setLoading(true);
//     try {

//       const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.SEND_OTP, {
//         phoneNumber: mobile,
//         type: "ORG_WEB"
//       });

//       console.log("my send otp", response)

//       // if (response?.success === true) {
//       //   // console.log(response?.data, "nnnnnnn")
//       //   toast.success(response?.data?.message);
//       //   setResOtp(response?.data?.otp);

//       //   setOtpSent(true);
//       // } else {
//       //   toast.error(response?.message || "Failed to send OTP");
//       // }
//     } catch (error) {
//       console.error("Send OTP error:", error);
//       toast.error("Something went wrong while sending OTP");
//     }
//     // setLoading(false);
//   };

//   const handleVerifyOTP = async (e: any) => {
//     e.preventDefault();

//     const otp = otpDigits.join("");
//     if (otp.length !== 4 || !/^\d{4}$/.test(otp)) {
//       setErrors({ otp: "Please enter a valid 4-digit OTP" });
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await axios.post(webServiceUrl.VERIFY_OTP, {
//         phoneNumber: mobile,
//         otp,
//         user: 'ORG'
//       });

//       if (response?.data?.success === true) {
//         const { accessToken, data } = response.data;
//         const { organization_id, organization_name } = data;
//         // Save to localStorage
//         localStorage.setItem("accessToken", accessToken);
//         localStorage.setItem("organization_id", organization_id);
//         localStorage.setItem("organization_name", organization_name);
//         toast.success(response.data.message);
//         // Redirect if needed
//         window.location.href = ('/lead-dashboard')
//         navigation("/lead-dashboard");
//       } else {
//         setErrors({ otp: "Incorrect OTP" });
//       }
//     } catch (error) {
//       console.error("OTP verification error:", error);
//       toast.error("Something went wrong during OTP verification");
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="login-page">
//       <div className="login-wrapper">
//         <>
//           <div className="left-panel">
//             <div className="left-content">
//               <h1 className="text-light">
//                 Nestfin: Uniting Teams,<br /> Streamlining HR
//               </h1>
//               <p>
//                 Efficiently manage your workforce,<br /> streamline operations effortlessly.
//               </p>
//             </div>
//           </div>

//           <div className="right-panel">
//             <form className="login-card">
//               <img src="assets/img/logo.png" alt="Nestfin Logo" className="login-logo" />

//               <h2 className="login-title">Welcome Back</h2>
//               <p className="login-subtext">
//                 Enter your mobile number to get started {resOtp}
//               </p>

//               <label htmlFor="mobile">Mobile Number</label>
//               <div className="input-group">
//                 <span className="input-group-text">+91</span>
//                 <input
//                   type="text"
//                   id="mobile"
//                   name="mobile"
//                   value={mobile}
//                   onChange={handleMobileChange}
//                   // onPaste={handlePaste}
//                   className="form-control"
//                   placeholder="Enter 10-digit number"
//                   maxLength={10}
//                   inputMode="numeric"
//                 />

//                 {/* <input
//                   type="text"
//                   id="mobile"
//                   name="mobile"
//                   minLength={10}
//                   value={mobile}
//                   onChange={handleMobileChange}
//                   className="form-control"
//                   placeholder="Enter 10-digit number"
//                 /> */}
//               </div>
//               {errors.mobile && <p className="text-danger">{errors.mobile}</p>}

//               {otpSent && (
//                 <>
//                   <label>Enter OTP</label>
//                   <div className="otp-box">
//                     {otpDigits.map((digit, index) => (
//                       <input
//                         key={index}
//                         type="text"
//                         maxLength={1}
//                         ref={otpRefs[index]}
//                         value={digit}
//                         onChange={(e) => handleOtpChange(index, e.target.value)}
//                         onKeyDown={(e) => handleOtpKeyDown(index, e)}
//                       />
//                     ))}
//                   </div>
//                   {errors.otp && <p className="text-danger">{errors.otp}</p>}
//                 </>
//               )}

//               {/* <button
//                   type="button"
//                   className={`btn-login ${otpSent ? "btn-verify" : "btn-send"}`}
//                   onClick={otpSent ? handleVerifyOTP : handleSendOTP}
//                 >
//                   {otpSent ? "Verify OTP" : "Send OTP"}
//                 </button> */}
//               <button
//                 style={{ marginTop: "50px" }}
//                 type="button"
//                 className={`btn-login ${otpSent ? "btn-verify" : "btn-send"}`}
//                 onClick={otpSent ? handleVerifyOTP : handleSendOTP}
//               // disabled={loading} // disable during loading
//               >
//                 {loading ? (
//                   <>
//                     <span className="spinner1" /> {/* use CSS spinner */}
//                     {otpSent ? "Verifying..." : "Sending..."}
//                   </>
//                 ) : (
//                   otpSent ? "Verify OTP" : "Send OTP"
//                 )}
//               </button>

//               <div className="footer-text mt-5">
//                 © {new Date().getFullYear()} Nestfin Technology. All rights reserved.
//               </div>
//             </form>
//           </div>
//         </>

//       </div>
//     </div>
//   );
// };

// export default Login;
